module.exports = __webpack_public_path__ + "static/media/asc-thumbs.93a29ae0.svg";